import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';

type HistoryEntry = {
  metrics: Metrics;
  inputSample: string;
};
interface HistoryState {
  collection: HistoryEntry[];
  currentIdx: number;
}

const initialState: HistoryState = {
  collection: [],
  currentIdx: -1
};

export const stepSlice = createSlice({
  name: 'history',
  initialState,
  reducers: {
    newCalculationStarted: state => {
      state.currentIdx = -1;
    },
    historyEntryAdded: (state, action: PayloadAction<HistoryEntry>) => {
      if (state.currentIdx === -1) {
        // Add to stack if this is a new calculation
        state.collection = [...state.collection, action.payload];
        state.currentIdx = state.collection.length - 1;
      } else {
        // Replace entry if user is editing calculation
        state.collection.splice(state.currentIdx, 1, action.payload);
      }
    },
    historyEntryDeleted: (state, action: PayloadAction<number>) => {
      state.collection.splice(action.payload, 1);
      if (action.payload === state.currentIdx) {
        // Set current Idx to new calculation
        state.currentIdx = -1;
      } else if (action.payload < state.currentIdx) {
        // Update current Idx if previous entry was deleted
        state.currentIdx = state.currentIdx - 1;
      }
    },
    historyReset: state => {
      state.collection = [];
    }
  }
});

export const {
  newCalculationStarted,
  historyEntryAdded,
  historyEntryDeleted,
  historyReset
} = stepSlice.actions;

export const historyCountSelector = (state: RootState) =>
  state.history.collection.length;

export const historyMetricsSelector = (state: RootState) =>
  state.history.collection.map(({ metrics }) => metrics);

export const historyIdxSelector = (state: RootState) =>
  state.history.currentIdx;

export const currentMetricsSelector = (state: RootState) =>
  state.history.collection[state.history.currentIdx].metrics;

export default stepSlice.reducer;
